<template>
    <div>
        <v-container>
            <v-row>
                <v-col class="text-center">
                    <v-alert type="success">Time off request has been approved.</v-alert>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import GuestLayout from "../../../Layouts/GuestLayout";

export default {
    name: "ApproveRequest",
    layout: [GuestLayout],
}
</script>

<style scoped>

</style>
